import { useFeature } from "./use-feature";

/** Alias fino — mantém o nome/API que os consumidores já usam (`ProductionStageBoardView.tsx`,
 *  `CustomRolesSection.tsx`), agora por cima do sistema geral de feature flags. */
export function useCustomizationLocked(): boolean {
  return !useFeature("customization");
}
